import {
  responseGetSettlements,
  failureGetSettlements,
  requestGetSettlements,
  responseDownloadSettlementsPDF,
  requestDownloadSettlementsPDF,
  failureDownloadSettlementsPDF,
  requestSendSettlementsEmail,
  responseSendSettlementsEmail,
  failureSendSettlementsEmail,
  requestGenerateBulkStore,
  responseGenerateBulkStore,
  failureGenerateBulkStore,
} from 'reactRedux/slices/settlementsSlice/SettlementsSlice';
import requestApi from 'utils/Request';
import { downloadFile } from 'utils/DownloadRequest';
import {
  SETTLEMENTS,
  DOWNLOAD_INVOICE,
  DOWNLOAD_INVOICE_BULK,
  DOWNLOAD_SELLER_INVOICE,
  SEND_INVOICE,
  SEND_INVOICE_BULK,
  INVOICE_GENERATE_BULK_STORE,
} from 'utils/StaticApiEndpoints';
import { showErrorAlert, showSuccessAlert } from 'utils/AlertUtils';
import { requestDownloadSettlementPDF } from 'reactRedux/slices/settlementsSlice/SettlementsSlice';
import { responseDownloadSettlementPDF } from 'reactRedux/slices/settlementsSlice/SettlementsSlice';
import { failureDownloadSettlementPDF } from 'reactRedux/slices/settlementsSlice/SettlementsSlice';
import { DOWNLOAD_SETTLEMENT } from 'utils/StaticApiEndpoints';

export const GetSettelementsData = (payload, callback) => async (dispatch) => {
  try {
    dispatch(requestGetSettlements());
    const { data } = await requestApi.get(`${SETTLEMENTS}`, {
      params: payload,
    });
    dispatch(responseGetSettlements(data));
    if (typeof callback === 'function') {
      callback();
    }
  } catch (error) {
    showErrorAlert(error?.message);
    dispatch(failureGetSettlements(error?.message));
  }
};

///////// Download Settlements PDF (Merchant Invoice) ////////
export const DownloadSettlementsPDF =
  (payload, callback) => async (dispatch) => {
    try {
      dispatch(requestDownloadSettlementsPDF());

      const defaultFilename = `INV-${payload.year}Y${payload?.quarter ? `Q${payload?.quarter}` : `M${payload?.month}`}-SP-${payload.name}`;

      await downloadFile(
        DOWNLOAD_INVOICE,
        payload,
        defaultFilename,
        'application/pdf',
        '.pdf',
        () => {
          dispatch(responseDownloadSettlementsPDF());
          if (typeof callback === 'function') {
            callback();
          }
        },
        (error) => {
          showErrorAlert(error?.message);
          dispatch(failureDownloadSettlementsPDF(error?.message));
        },
      );
    } catch (error) {
      showErrorAlert(error?.message);
      dispatch(failureDownloadSettlementsPDF(error?.message));
    }
  };

///////// Download Seller Invoice PDF ////////
export const DownloadSellerInvoicePDF =
  (payload, callback, onError) => async (dispatch) => {
    try {
      dispatch(requestDownloadSettlementsPDF());

      const defaultFilename = `INV-${payload.year}Y${payload?.quarter ? `Q${payload?.quarter}` : `M${payload?.month}`}-SP-${payload.name}`;

      await downloadFile(
        DOWNLOAD_SELLER_INVOICE,
        {
          sellerId: payload.sellerId,
          year: payload.year,
          ...(payload?.quarter
            ? { quarter: payload.quarter }
            : { month: payload.month }),
          ...(payload?.language &&
            payload.language !== 'en' && { language: payload.language }),
        },
        defaultFilename,
        'application/pdf',
        '.pdf',
        () => {
          dispatch(responseDownloadSettlementsPDF());
          if (typeof callback === 'function') {
            callback();
          }
        },
        (error) => {
          dispatch(failureDownloadSettlementsPDF(error?.message));
          if (typeof onError === 'function') {
            onError();
          }
          showErrorAlert(error?.message);
        },
      );
    } catch (error) {
      dispatch(failureDownloadSettlementsPDF(error?.message));
      if (typeof onError === 'function') {
        onError();
      }
      showErrorAlert(error?.message);
    }
  };

/////// Generate Bulk Store ////////
export const GenerateBulkStore = (payload, callback) => async (dispatch) => {
  try {
    dispatch(requestGenerateBulkStore());
    const response = await requestApi.get(`${INVOICE_GENERATE_BULK_STORE}`, {
      params: payload,
    });

    if (response?.statusCode === 200) {
      showSuccessAlert('Invoices generated and stored successfully!');
      dispatch(responseGenerateBulkStore());
      if (typeof callback === 'function') {
        callback();
      }
    } else {
      // Handle non-200 responses
      showErrorAlert('Failed to generate invoices. Please try again.');
      dispatch(
        failureGenerateBulkStore(
          response?.message || 'Failed to generate invoices',
        ),
      );
    }
  } catch (error) {
    showErrorAlert('An error occurred while generating invoices.');
    dispatch(failureGenerateBulkStore(error?.message));
  }
};

///////// Send Settlements Email ////////
export const SendSettlementsEmail = (payload, callback) => async (dispatch) => {
  try {
    dispatch(requestSendSettlementsEmail());
    const response = await requestApi.get(`${SEND_INVOICE}`, {
      params: payload,
    });

    if (response?.statusCode === 200) {
      showSuccessAlert('Email sent successfully!');
      dispatch(responseSendSettlementsEmail());
      if (typeof callback === 'function') {
        callback();
      }
    } else {
      // Handle non-200 responses
      showErrorAlert('Failed to send email. Please try again.');
      dispatch(
        failureSendSettlementsEmail(
          response?.message || 'Failed to send email',
        ),
      );
    }
  } catch (error) {
    showErrorAlert('An error occurred while sending email.');
    dispatch(failureSendSettlementsEmail(error?.message));
  }
};

/////// Send Settlements Email Bulk ////////
export const SendSettlementsEmailBulk =
  (payload, callback) => async (dispatch) => {
    try {
      dispatch(requestSendSettlementsEmail());
      const response = await requestApi.get(`${SEND_INVOICE_BULK}`, {
        params: payload,
      });

      if (response?.statusCode === 200) {
        showSuccessAlert('Emails sent successfully!');
        dispatch(responseSendSettlementsEmail());
        if (typeof callback === 'function') {
          callback();
        }
      } else {
        // Handle non-200 responses
        showErrorAlert('Failed to send emails. Please try again.');
        dispatch(
          failureSendSettlementsEmail(
            response?.message || 'Failed to send emails',
          ),
        );
      }
    } catch (error) {
      showErrorAlert('An error occurred while sending emails.');
      dispatch(failureSendSettlementsEmail(error?.message));
    }
  };

////// Settlement Module download PDF ////////
export const DownloadSettlementPDF =
  (payload, callback) => async (dispatch) => {
    try {
      dispatch(requestDownloadSettlementPDF());

      const defaultFilename = 'P&L Statement';

      await downloadFile(
        DOWNLOAD_SETTLEMENT,
        payload,
        defaultFilename,
        'application/pdf',
        '.pdf',
        () => {
          dispatch(responseDownloadSettlementPDF());
          if (typeof callback === 'function') {
            callback();
          }
        },
        (error) => {
          showErrorAlert(error?.message);
          dispatch(failureDownloadSettlementPDF(error?.message));
        },
      );
    } catch (error) {
      showErrorAlert(error?.message);
      dispatch(failureDownloadSettlementPDF(error?.message));
    }
  };

/////// Download Settlements PDF Bulk (Merchant Invoice) ////////
export const DownloadSettlementsPDFBulk =
  (payload, callback) => async (dispatch) => {
    try {
      dispatch(requestDownloadSettlementsPDF());

      const defaultFilename = `Bulk-INV-${payload.year}Y${payload?.quarter ? `Q${payload?.quarter}` : `M${payload?.month}`}`;

      await downloadFile(
        DOWNLOAD_INVOICE_BULK,
        payload,
        defaultFilename,
        'application/zip',
        '.zip',
        () => {
          dispatch(responseDownloadSettlementsPDF());
          if (typeof callback === 'function') {
            callback();
          }
        },
        (error) => {
          showErrorAlert(error?.message);
          dispatch(failureDownloadSettlementsPDF(error?.message));
        },
      );
    } catch (error) {
      showErrorAlert(error?.message);
      dispatch(failureDownloadSettlementsPDF(error?.message));
    }
  };
